import { render, staticRenderFns } from "./AIEvaluationReviewWorkspace_v2.vue?vue&type=template&id=acfd873c&scoped=true&"
import script from "./AIEvaluationReviewWorkspace_v2.vue?vue&type=script&lang=js&"
export * from "./AIEvaluationReviewWorkspace_v2.vue?vue&type=script&lang=js&"
import style0 from "./AIEvaluationReviewWorkspace_v2.vue?vue&type=style&index=0&id=acfd873c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfd873c",
  null
  
)

export default component.exports